import { useState } from "react";
import { LineChart } from "@mui/x-charts";
import { useTranslation } from "react-i18next";

export default function AdChartsUi ({value, onFilterChange}) {

    const { t } = useTranslation();

    const currentYear = new Date().getFullYear();
    const [selectedYear, setSelectedYear] = useState(null);
    const [selectedMonth, setSelectedMonth] = useState(null);

    const years = Array.from({ length: 10 }, (_, i) => currentYear - i);

    const months = [
        { value: "1", label: t("January") || "January" },
        { value: "2", label: t("February") || "February" },
        { value: "3", label: t("March") || "March" },
        { value: "4", label: t("April") || "April" },
        { value: "5", label: t("May") || "May" },
        { value: "6", label: t("June") || "June" },
        { value: "7", label: t("July") || "July" },
        { value: "8", label: t("August") || "August" },
        { value: "9", label: t("September") || "September" },
        { value: "10", label: t("October") || "October" },
        { value: "11", label: t("November") || "November" },
        { value: "12", label: t("December") || "December" },
    ];

    const handleYearChange = (e) => {
        const newYear = e.target.value;
        setSelectedYear(newYear);
        setSelectedMonth(null);
        if (onFilterChange) onFilterChange({ year: newYear, month: null });
    };

    const handleMonthChange = (e) => {
        const newMonth = e.target.value;
        setSelectedMonth(newMonth);
        setSelectedYear(null);
        if (onFilterChange) onFilterChange({ year: null, month: newMonth });
    };

    // Extract data safely
    const chartData = value?.active_user_by_time || [];
    
    // Map the "time" (Months) to X-axis and "count" to Y-axis
    const xLabels = chartData.map((item) => item.time);
    const seriesData = chartData.map((item) => item.count);

    return (
            <div className="chart-wrap w-full bg-thirdly flex flex-col justify-center gap-3 px-4 mt-6 rounded-lg">
                
                {/* Header: Filters (Left) & Label (Right) */}
                <div className="flex sm:flex-row flex-col-reverse justify-between items-center my-6 gap-4">
                    
                    {/* Filters Section */}
                    <div className="flex gap-3">
                        {/* Year Select */}
                        <select
                            value={selectedYear || ""}
                            onChange={handleYearChange}
                            className="bg-white/10 border border-white/20 text-white text-sm rounded-md px-3 py-1 outline-none focus:border-blue-500 cursor-pointer placeholder-gray-400"
                        >
                            <option value="" disabled className="text-gray-500">{t("Select Year")}</option>
                            {years.map((year) => (
                                <option key={year} value={year} className="text-black">
                                    {year}
                                </option>
                            ))}
                        </select>

                        {/* Month Select */}
                        <select
                            value={selectedMonth || ""}
                            onChange={handleMonthChange}
                            className="bg-white/10 border border-white/20 text-white text-sm rounded-md px-3 py-1 outline-none focus:border-blue-500 cursor-pointer"
                        >
                            <option value="" disabled className="text-gray-500">{t("Select Month")}</option>
                            {months.map((m) => (
                                <option key={m.value} value={m.value} className="text-black">
                                    {m.label}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* Title */}
                    <label className='text-white font-semibold text-lg text-right'>
                        {t("charts.active_user")}
                    </label>
                </div>

                {/* Chart */}
                <LineChart
                    xAxis={[
                        {
                            data: xLabels,
                            scaleType: 'point', 
                            // label: 'Date',
                            labelOffset: 10,
                            height: 50,
                        },
                    ]}
                    yAxis={[{ label: "active ads" }]}
                    series={[
                        {
                            data: seriesData,
                            color: "#3b82f6",
                            area: true,
                            curve: "natural",
                        },
                    ]}
                    height={370}
                    grid={{ vertical: true, horizontal: true, curve: "natural" }}
                />
            </div>
        );
};